export default {
  label: '总会计师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '总会计师是企业经济核算和财务会计工作的负责人，通常在国有企业、事业单位中担任重要角色',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '贯彻执行国家财经政策，维护财经纪律',
          id: '0-2-1',
        },
        {
          label: '参与制定公司经营方针、策略和发展规划',
          id: '0-2-2',
        },
        {
          label: '审查重要经济合同，预测财务成果，参与重大项目可行性研究',
          id: '0-2-3',
        },
        {
          label: '组织全面经济核算，定期召开经济活动分析会议',
          id: '0-2-4',
        },
        {
          label: '审核财务报表和纳税信息，进行税务筹划',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '本科及以上学历，会计或财务管理相关专业',
          id: '0-3-1',
        },
        {
          label: '至少5年以上财务管理经验，其中至少3年同岗位经验',
          id: '0-3-2',
        },
        {
          label: '拥有高级会计师或注册会计师资格优先',
          id: '0-3-3',
        },
        {
          label: '熟悉财经法律法规和制度',
          id: '0-3-4',
        },
        {
          label: '具备较强的组织协调能力和决策能力',
          id: '0-3-5',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '20-30万元',
          id: '0-4-1',
        },
      ],
    }
  ],
};